module.exports = __webpack_public_path__ + "img/how-to_blocks.6dcf5dc8.png";